import { Component, ContentChild, TemplateRef } from '@angular/core';

@Component({
  selector: 'sm-dt-rollout',
  template: '<!-- rollout row -->',
  standalone: false
})
export class RolloutComponent {
  @ContentChild(TemplateRef)
    template: TemplateRef<any>;
}
